import gql from 'graphql-tag';

const CAMPAIGN_ORDER_BASKET_BY_DATE = gql`
  query campaignOrderBasketByDate($id: ID!) {
    campaignOrderTransactionsBasketItemsByDates(
      where: { campaignOrderTransactionReport: { analytics: { campaignOrder: { id: $id } } } }
    ) {
      id
      date
      transactions
      revenue
      quantity
    }
  }
`;

export default CAMPAIGN_ORDER_BASKET_BY_DATE;
